/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React, { useEffect } from "react";
import { connectWithSocketServer } from "./SocketConnection";
import * as ts from "timesync";

let timesync = null;

const Socket = React.memo(() => {
    useEffect(() => {
        console.log("Creating Socket");
        connectWithSocketServer();
        return () => {
            if (timesync) timesync.destroy();
        };
    });

    if (!timesync) {
        timesync = ts.create({
            server: `https://${process.env.REACT_APP_BACKEND_HOST || window.location.hostname
                }:${process.env.REACT_APP_BACKEND_PORT || window.location.port}/timesync`,
            interval: 10000,
        });
    }

    return null;
});

export default Socket;
